const backups = [{
  path: '/backups',
  name: 'backups',
  component: () => import('@/views/backups'),
  meta: {
    title: '数据备份'
  }
}]

export default backups



// WEBPACK FOOTER //
// ./src/router/setting/backups.js